import { Headphones, Clock, Bookmark, Wifi } from "lucide-react";

const benefits = [
  { icon: Headphones, title: "Narración profesional", desc: "Voces cuidadosamente seleccionadas que dan vida a cada texto sagrado." },
  { icon: Clock, title: "Escucha en cualquier momento", desc: "Mientras caminas, cocinas o antes de dormir. Tu momento espiritual, cuando quieras." },
  { icon: Bookmark, title: "Retoma donde lo dejaste", desc: "Guardamos tu progreso automáticamente. Nunca pierdas tu lugar." },
  { icon: Wifi, title: "Streaming o descarga", desc: "Escucha en línea o descarga para disfrutar sin conexión." },
];

export function Benefits() {
  return (
    <section className="py-24 bg-section-alt">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-4">
          Diseñado para escuchar
        </h2>
        <p className="text-center text-muted-foreground mb-16 max-w-lg mx-auto">
          La experiencia de audio es nuestra prioridad.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {benefits.map((b, i) => (
            <div key={i} className="bg-card rounded-xl p-6 border border-border hover:border-primary/30 transition-colors">
              <div className="w-12 h-12 rounded-lg bg-accent-gold/10 flex items-center justify-center mb-4">
                <b.icon className="h-6 w-6 text-accent-gold" />
              </div>
              <h3 className="font-heading font-bold text-foreground mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
